import { createFileRoute } from "@tanstack/react-router";
import { canonicalLinks, ogUrl, SITE_URL, ogImage, jsonLd, breadcrumbSchema } from "@/lib/seo";
import { CharityPage } from "@/components/site/CharityPage";
import { getCharity } from "@/data/charities";

const charity = getCharity("coptic-orphans")!;

export const Route = createFileRoute("/giving/coptic-orphans")({
  head: () => ({
    meta: [
      { title: charity.metaTitle },
      { name: "description", content: charity.metaDescription },
      { property: "og:title", content: charity.metaTitle },
      { property: "og:description", content: charity.metaDescription },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: charity.metaTitle },
      { name: "twitter:description", content: charity.metaDescription },
      ...ogImage("giving-coptic-orphans", "Coptic Orphans, a cause we list"),
      ogUrl("/giving/coptic-orphans"),
    ],
    links: canonicalLinks("/giving/coptic-orphans"),
    scripts: [
      jsonLd(breadcrumbSchema([{ name: "Giving", path: "/giving" }, { name: charity.name, path: "/giving/coptic-orphans" }])),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "NGO",
          name: charity.fullName,
          description: charity.blurb,
          url: charity.site,
          areaServed: "Egypt",
          subjectOf: { "@type": "WebPage", url: `${SITE_URL}/giving/coptic-orphans` },
        }),
      },
    ],
  }),
  component: () => <CharityPage charity={charity} />,
});
